import { GroupedItems } from './groupedItems'

export function groupItems<T>(
    items: T[],
    getGroupKey: (item: T) => string | undefined,
    getGroupTagKey?: (item: T) => string | undefined,
    options: {
        sortGroups?: (a: string, b: string) => number
        sortItems?: (a: T, b: T) => number
        filterGroups?: (items: T[]) => boolean
    } = {},
): GroupedItems<T>[] {
    const groups = items.reduce((acc, item) => {
        const groupKey = getGroupKey(item)

        if (!groupKey) return acc

        const existingGroup = acc.find(group => group.label === groupKey)

        if (existingGroup) {
            existingGroup.items.push(item)
        } else {
            acc.push({ label: groupKey, items: [item], tag: getGroupTagKey ? getGroupTagKey(item) : undefined })
        }

        return acc
    }, [] as GroupedItems<T>[])

    // Apply sorting and filtering
    return groups
        .filter(group => !options.filterGroups || options.filterGroups(group.items))
        .map(group => ({
            ...group,
            items: options.sortItems ? [...group.items].sort(options.sortItems) : group.items
        }))
        .sort((a, b) =>
            options.sortGroups ? options.sortGroups(a.label, b.label) : a.label.localeCompare(b.label)
        )
}